import { Avatar } from "@cryptors/api-client";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { IResourceComponentsProps } from "@refinedev/core";
import {
  EditButton,
  ShowButton,
  List,
  DateField,
  useDataGrid,
} from "@refinedev/mui";
import React, { useMemo } from "react";

import { DeleteIconButton } from "@/components/forms/DeleteIconButton";

export const AvatarList: React.FC<IResourceComponentsProps> = () => {
  const { dataGridProps } = useDataGrid<Avatar>({
    resource: "avatars",
    pagination: { pageSize: 25 },
    sorters: { initial: [{ field: "id", order: "desc" }] },
  });

  const columns = useMemo<GridColDef<Avatar>[]>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 50,
      },
      {
        field: "image.url",
        headerName: "Image",
        flex: 1,
        sortable: false,
        minWidth: 50,
        valueGetter: (_value, row) => row.image?.url,
        renderCell: function render({ value }) {
          return <img src={value} alt="Avatar" width="50" />;
        },
      },
      {
        field: "createdAt",
        headerName: "Date de création",
        minWidth: 50,
        renderCell: function render({ value }) {
          return <DateField value={value} />;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <ShowButton hideText recordItemId={row.id} />
              <DeleteIconButton recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 160,
      },
    ],
    [],
  );

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        pageSizeOptions={[10, 25, 50, 100]}
      />
    </List>
  );
};
